<template>
    <div class="search-flight">
        <div class="search-flight-btns">
            <button
                class="btn-way"
                :class="btn.class"
                @click="changeWay(btn)"
                v-for="(btn,index) in wayBtns"
                :key="index"
            >{{btn.name}}</button>
        </div>
        <div class="search-row">
            <div class="input-box" style="width: 520px;">
                <div class="input-box-inner">
                    <div class="icon-container">
                        <i class="iconfont icon-location"></i>
                    </div>
                    <div class="search-input" ref="origin">
                        <div>{{$t('depart')}}</div>
                        <input
                            type="text"
                            :placeholder="$t('city_airport')"
                            v-model="filterForm.origin"
                            @input="searchStartPort"
                            @click="showStartPanel = !showStartPanel"
                            autocomplete="new-password"
                        />
                        <!-- 热门推荐 -->
                        <flight-search-panel :visible.sync="showStartPanel" @select="selectOrigin" />
                        <!-- 搜索弹框 -->
                        <search-location
                            v-show="showStart"
                            :is-loading="showStartLoading"
                            :data="showStartData"
                            @menu-select="selectOrigin"
                        ></search-location>
                    </div>
                    <div class="reverse-icon" @click="reverseWay">
                        <i v-if="wayType === 'OneWay'" class="iconfont icon-icon_to_blackx"></i>
                        <i v-else class="iconfont icon-flight_roundway"></i>
                    </div>
                    <div class="search-input" ref="destination">
                        <div>{{$t('arrive')}}</div>
                        <input
                            type="text"
                            :placeholder="$t('city_airport')"
                            v-model="filterForm.destination"
                            @input="searchEndPort"
                            @click="showEndPanel = !showEndPanel"
                            autocomplete="new-password"
                        />
                        <!-- 热门推荐 -->
                        <flight-search-panel :visible.sync="showEndPanel" @select="selectDest" />
                        <!-- 搜索弹框 -->
                        <search-location
                            v-show="showEnd"
                            :is-loading="showEndLoading"
                            :data="showEndData"
                            @menu-select="selectDest"
                        ></search-location>
                    </div>
                </div>
            </div>
            <div class="input-box" style="width: 317px;">
                <div class="input-box-inner">
                    <div class="icon-container">
                        <i class="el-input__icon el-icon-date"></i>
                    </div>
                    <div class="search-input search-date">
                        <div>{{$t('startDate')}}</div>
                        <el-date-picker
                            v-model="dater"
                            type="date"
                            :picker-options="startOption"
                            :clearable="false"
                            :editable="false"
                            :format="displayDate"
                        ></el-date-picker>
                        <i class="iconfont icon-arrow-down"></i>
                    </div>
                    <div class="search-input search-date" v-show="wayType === 'Return'">
                        <div>{{$t('endDate')}}</div>
                        <el-date-picker
                            v-model="returnDater"
                            type="date"
                            :picker-options="endOption"
                            :clearable="false"
                            :editable="false"
                            :format="displayReturnDate"
                        ></el-date-picker>
                        <i class="iconfont icon-arrow-down"></i>
                    </div>
                </div>
            </div>
            <div class="input-box" style="flex: 1;">
                <div class="input-box-inner">
                    <div class="icon-container">
                        <i class="iconfont icon-user-group"></i>
                    </div>
                    <div class="search-input" ref="pMenu">
                        <div>{{$t('count_man')}}</div>
                        <input
                            type="text"
                            class="input-item"
                            v-model="filterForm.persion"
                            readonly="readonly"
                            @click="showPMenu=!showPMenu"
                        />
                        <persion-menu :show="showPMenu" @i-select="pMenuSelect"></persion-menu>
                    </div>
                </div>
            </div>
        </div>
        <div class="class-input" ref="cMenu" @click="showClassMenu=true">
            <span>{{filterForm.cabinTypeName}}</span>
            <i class="iconfont icon-arrow-down"></i>
            <class-select v-show="showClassMenu" @select="classSelect"></class-select>
        </div>
        <button class="btn btn-warning btn-block search-btn" @click="search">{{$t('search')}}</button>
    </div>
</template>

<script>
import moment from "moment";
import PersionMenu from "@/views/AirTicket/components/PersionMenu";
import SearchLocation from "@/views/AirTicket/components/SearchLocation";
import ClassSelect from "@/views/AirTicket/components/ClassSelect";
import FlightSearchPanel from "./FlightSearchPanel";
import { debounce, linkTo } from "@/lib/utils";
import { flightSearchGtag } from "@/lib/gtag.js";
import axios from "axios";

export default {
    name: "flightSearch",
    components: {
        PersionMenu,
        SearchLocation,
        ClassSelect,
        FlightSearchPanel
    },
    data() {
        return {
            dater: moment()
                .add(1, "days")
                .startOf("d"),
            returnDater: moment()
                .add(2, "days")
                .startOf("d"),
            displayDate: "MM-dd",
            displayReturnDate: "MM-dd",
            wayType: "OneWay",
            wayBtns: [
                {
                    name: this.$t("oneway"),
                    AirTripType: "OneWay",
                    class: "btn-way-active"
                },
                {
                    name: this.$t("return"),
                    AirTripType: "Return",
                    class: ""
                }
            ],
            filterForm: {
                cabinType: "Y", //舱位类型
                cabinTypeName: this.$t("economy_cab"), //舱位名称
                origin: "", //出发地
                originCode: "",
                destination: "", //目的地
                destinationCode: "",
                persion: `1 ${this.$t("adult")}`, //人数及结构
                persionData: {
                    adt: 1
                },
                airCompanys: [],
                airCompanyCodes: []
            },
            showStart: false,
            showStartPanel: false,
            showEnd: false,
            showEndPanel: false,
            showStartData: [],
            showEndData: [],
            showPMenu: false,
            showClassMenu: false,
            showStartLoading: false,
            showEndLoading: false,
            startOption: {
                disabledDate: function(nowDate) {
                    return moment().isAfter(nowDate, "days");
                }
            },
            isSearching: false,
            source: null
        };
    },
    computed: {
        endOption() {
            let dater = this.dater;
            return {
                disabledDate: function(nowDate) {
                    return moment(dater).isAfter(nowDate, "days");
                }
            };
        }
    },
    watch: {
        dater(value) {
            this.setFormatDate(value);
            //出发时间如果晚于返程时间则强制同步返程时间与出发时间一致
            if (moment(value).isAfter(this.returnDater)) {
                this.returnDater = moment(value).add(1, "d");
            }
        },
        returnDater(value) {
            this.setFormatReturnDate(value);
        }
    },
    mounted() {
        this.$store.dispatch("setFlightHotCity");
        let pMenu = this.$refs.pMenu;
        let origin = this.$refs.origin;
        let cMenu = this.$refs.cMenu;
        let destination = this.$refs.destination;
        document.addEventListener("click", e => {
            if (!pMenu.contains(e.target)) {
                this.showPMenu = false;
            }
            if (!cMenu.contains(e.target)) {
                this.showClassMenu = false;
            }
            if (!origin.contains(e.target)) {
                this.showStart = false;
            }
            if (!destination.contains(e.target)) {
                this.showEnd = false;
            }
        });
        this.currentMargin = (window.innerWidth - 1240) / 2;
        this.setFormatDate(this.dater);
        this.setFormatReturnDate(this.returnDater);

        const cancelToken = axios.CancelToken;
        this.source = cancelToken.source();
    },
    methods: {
        //单程 or 双程切换
        changeWay(btn) {
            //清空航空公司列表
            this.airList = [];

            btn.class = "btn-way btn-way-active";
            this.wayType = btn.AirTripType;
            for (let item of this.wayBtns) {
                if (item.name !== btn.name) {
                    item.class = "btn-way";
                }
            }
        },
        reverseWay() {
            let origin = this.filterForm.origin;
            let oCode = this.filterForm.originCode;
            let destination = this.filterForm.destination;
            let dCode = this.filterForm.destinationCode;

            this.filterForm.origin = destination;
            this.filterForm.destination = origin;
            this.filterForm.originCode = dCode;
            this.filterForm.destinationCode = oCode;
        },
        classSelect(type, name) {
            this.showClassMenu = false;
            this.filterForm.cabinType = type;
            this.filterForm.cabinTypeName = name;
        },
        //乘客选择
        pMenuSelect(data) {
            this.filterForm.persionData = data[0];
            this.filterForm.persion = `${data[0].adt}${this.$t("adult")}`;
            if (data[0].chd) {
                this.filterForm.persion += `，${data[0].chd}${this.$t(
                    "child"
                )}`;
            }
            if (data[0].inf) {
                this.filterForm.persion += `，${data[0].inf}${this.$t(
                    "infant"
                )}`;
            }
        },
        //格式化表单出发日期
        setFormatDate(value) {
            //! 需迁徙到中英文全局设置部分
            // moment.locale('zh-cn')
            // moment.locale('en')
            let date = moment(this.dater).format("MM-DD ddd");
            this.displayDate = '"' + date + '"';
        },
        //格式化表单出发日期
        setFormatReturnDate(value) {
            //! 需迁徙到中英文全局设置部分
            // moment.locale('zh-cn')
            // moment.locale('en')
            let date = moment(this.returnDater).format("MM-DD ddd");
            this.displayReturnDate = '"' + date + '"';
        },
        //点击搜索按钮
        search() {
            if (!this.filterForm.originCode) {
                this.$msg.error(this.$t("msg_start"));
                return;
            }
            if (!this.filterForm.destinationCode) {
                this.$msg.error(this.$t("msg_end"));
                return;
            }

            this.$local.set("flight.search", {
                filterForm: this.filterForm,
                dater: this.dater,
                returnDater: this.returnDater,
                type: this.wayType
            });

            //埋点
            flightSearchGtag({
                '出发城市': this.filterForm.origin,
                '到达城市': this.filterForm.destination,
                '单程/往返': this.wayType === 'OneWay' ? '单程': '往返',
                '出行日期': this.dater,
                '乘机人数': this.filterForm.persion,
                '选择舱位': this.filterForm.cabinTypeName
            })

            linkTo("/airticket");
        },
        searchStartPort() {
            this.showStartPanel = false;
            if (this.filterForm.origin.trim() !== "") {
                this.showStart = true;
                this.showStartLoading = true;
                debounce(this.reqSearchPort, 1000)(
                    "showStart",
                    this.filterForm.origin
                );
            } else {
                this.showStart = false;
                this.showStartLoading = false;
            }
        },
        searchEndPort() {
            this.showEndPanel = false;
            if (this.filterForm.destination.trim() !== "") {
                this.showEnd = true;
                this.showEndLoading = true;
                debounce(this.reqSearchPort, 1000)(
                    "showEnd",
                    this.filterForm.destination
                );
            } else {
                this.showEnd = false;
                this.showEndLoading = false;
            }
        },
        //选择起始地
        selectOrigin(value, code) {
            this.filterForm.origin = value;
            this.filterForm.originCode = code;
            this.showStart = false;
        },
        //选择目的地
        selectDest(value, code) {
            this.filterForm.destination = value;
            this.filterForm.destinationCode = code;
            this.showEnd = false;
        },
        //根据字符串远程搜索
        reqSearchPort(type, value) {
            //清空上次请求结果
            this[type + "Data"] = [];
            if (type === "showStart") {
                this.filterForm.originCode = "";
            } else {
                this.filterForm.destinationCode = "";
            }

            const reg = /^[a-zA-Z(\s)]*$/;
            if (!value) {
                return;
            }
            if (!reg.test(value)) {
                this.$msg.error(this.$t("msg_en"));
                return;
            }

            //防止上一次搜索的结果覆盖当前搜索结果
            if (this.isSearching) {
                this.source.cancel();
            }

            this.isSearching = true;
            this.$req
                .post("v3/searchport", {
                    value: value
                })
                .then(({ data }) => {
                    if (data.code == 2000 && data.data) {
                        this[type + "Data"] = data.data;
                    } else if (data.code == 2000 && !data.data) {
                        this[type + "Data"] = [];
                    } else {
                        this.$msg.error(data.msg);
                    }
                })
                .finally(() => {
                    this[type + "Loading"] = false;
                    this.isSearching = false;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.input-box /deep/ .el-input__inner {
    background-color: transparent;
    height: 25px;
    border: none;
    padding-left: 0;
    color: #767676;
    font-size: 16px;
}
.input-box /deep/ .el-date-editor {
    width: 100%;
}
.input-box /deep/ .el-input__prefix {
    display: none;
}

.search-btn {
    box-sizing: border-box;
    width: 160px;
    height: 60px;
    position: absolute;
    left: 50%;
    margin-left: -80px;
    // bottom: 100px;
    // left: 550px;
    font-size: 24px;
    font-weight: 500;
    border-radius: 50px;
    box-shadow: 2px 5px 10px rgba(0, 0, 0, 0.2);

    &:active {
        opacity: 0.7;
    }
}

.class-input {
    width: 200px;
    position: relative;
    cursor: pointer;
    box-sizing: border-box;
    padding: 5px;
    color: #767676;

    i {
        margin-left: 10px;
    }
}

.search-flight {
    .search-flight-btns {
        padding: 20px 0;

        .btn-way {
            height: 25px;
            box-sizing: border-box;
            border: 1px solid #00a9ba;
            border-radius: 5px;
            padding: 0 12px;
            font-size: 14px;
            background-color: #fff;
            margin-right: 27px;
            color: #00a9ba;
            cursor: pointer;
            transition: all ease-in-out 0.3s;
        }

        .btn-way-active {
            background-color: #00a9ba;
            color: #fff;
        }
    }

    .search-row {
        display: flex;
        justify-content: space-around;

        .input-box {
            box-sizing: border-box;
            padding: 3px;

            .input-box-inner {
                display: flex;
                justify-content: space-around;
                align-items: center;
                height: 68px;
                padding-right: 10px;
                border-radius: 2px;
                background: #f6f6f6;

                .iconfont {
                    color: #767676;
                }

                .icon-container {
                    padding: 18px 10px 0;
                    width: 45px;
                    box-sizing: border-box;

                    i {
                        font-size: 24px;
                        color: #767676;
                    }
                }
            }

            .reverse-icon {
                padding: 18px 10px 0;
                width: 50px;
                box-sizing: border-box;
                cursor: pointer;

                .iconfont {
                    font-size: 12px;
                }
            }

            .search-date {
                height: 43px;
                position: relative;

                .iconfont {
                    position: absolute;
                    top: 19px;
                    right: 10px;
                    // z-index: -1;
                }
            }

            .search-input {
                color: #767676;
                flex: 1;
                position: relative;

                div {
                    font-size: 12px;
                    margin-bottom: 5px;
                }

                input {
                    background-color: transparent;
                    color: #767676;
                    box-sizing: border-box;
                    width: 100%;
                    &::-webkit-input-placeholder {
                        color: rgba(118, 118, 118, 0.6);
                    }
                }
            }
        }
    }
}
.btn-spec {
    background-color: #00a9ba !important;
    color: #767676 !important;
    box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Public/components/FlightSearch.vue